import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface masterListProps {
  id: string;
  displayName: string;
}

const initialState = {
  ageRangeList: [] as masterListProps[],
  participantCategoryList: [] as masterListProps[],
  activityList: [] as masterListProps[],
};

const MasterSliceReducer = createSlice({
  name: "MasterSliceReducer",
  initialState,
  reducers: {
    setAgeRangeList: (state, action: PayloadAction<masterListProps[]>) => {
      state.ageRangeList = action.payload;
    },
    setParticipantCategoryList: (
      state,
      action: PayloadAction<masterListProps[]>,
    ) => {
      state.participantCategoryList = action.payload;
    },
    setActivityList: (state, action: PayloadAction<masterListProps[]>) => {
      state.activityList = action.payload;
    },
  },
});

export const { setAgeRangeList, setParticipantCategoryList, setActivityList } =
  MasterSliceReducer.actions;

export default MasterSliceReducer.reducer;
